module.exports = __webpack_public_path__ + "media/images/no_image-9454bb97b04a34fda9ff7ad1820c8def.jpg";